import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/plane-transit.svg'
import _imports_1 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-a03d02d6")

_pushScopeId("data-v-a03d02d6")
const _hoisted_1 = { class: "mb-5 pb-3 overflow-x-scroll frame relative z-10" }
const _hoisted_2 = { "aria-describedby": "table plane transit" }
const _hoisted_3 = { class: "text-center text-12px text-black-lp-300 bg-gray-lp-700 p-10" }
const _hoisted_4 = { class: "flex flex-row items-end justify-center gap-0.5 text-black-lp-200 font-semibold" }
const _hoisted_5 = {
  key: 0,
  class: "text-red-lp-300 font-normal"
}
const _hoisted_6 = { class: "py-4" }
const _hoisted_7 = {
  key: 0,
  class: "grid place-items-center"
}
const _hoisted_8 = { class: "pl-2" }
const _hoisted_9 = { class: "w-1/6" }
const _hoisted_10 = { class: "w-1/6" }
const _hoisted_11 = {
  key: 0,
  class: "flex"
}
const _hoisted_12 = { class: "flex flex-row" }
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5 mr-2",
  alt: "exclamation-triangle"
}, null, -1)
const _hoisted_14 = { class: "w-2/6 pr-2" }
const _hoisted_15 = { class: "w-2/6" }
const _hoisted_16 = { class: "text-red-lp-300 font-normal text-14px flex flex-row items-start mt-2" }
const _hoisted_17 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5 mr-2",
  alt: "exclamation-triangle"
}, null, -1)
const _hoisted_18 = { class: "whitespace-nowrap" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_PvDropdown = _resolveComponent("PvDropdown")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("table", _hoisted_2, [
        _createVNode("thead", _hoisted_3, [
          _createVNode("tr", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.table.header, (head, index) => {
              return (_openBlock(), _createBlock("th", {
                key: index,
                class: 
              `py-4 ${index === 0 ? 'rounded-l-lg pl-2.5 pr-1' : 'px-1'} ${
                index === _ctx.table.header.length - 1 ? 'rounded-r-lg' : ''
              }`
            ,
                style: `width: ${head.width};`,
                id: head.label
              }, [
                _createVNode("span", _hoisted_4, [
                  _createTextVNode(_toDisplayString(head.label) + " ", 1),
                  (head.asterisk)
                    ? (_openBlock(), _createBlock("span", _hoisted_5, " * "))
                    : _createCommentVNode("", true)
                ])
              ], 14, ["id"]))
            }), 128))
          ])
        ]),
        _createVNode("tbody", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.activeDataSchedule, (schedule, index) => {
            return (_openBlock(), _createBlock(_Fragment, { key: index }, [
              _createVNode("tr", _hoisted_6, [
                _createVNode("td", null, [
                  (!schedule.isTransit)
                    ? (_openBlock(), _createBlock("div", _hoisted_7, [
                        _createVNode("span", _hoisted_8, _toDisplayString(_ctx.getNumber(schedule)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("td", null, [
                  (!schedule.isTransit)
                    ? (_openBlock(), _createBlock(_component_Datepicker, {
                        class: "mt-2 mr-1 plane-datepicker",
                        modelValue: schedule.endTime,
                        "onUpdate:modelValue": [($event: any) => (schedule.endTime = $event), 
                  value => _ctx.formatCutOffTimeValue({ value, index })
                ],
                        showDatePicker: false,
                        showTimePicker: "",
                        manualInput: "",
                        showIcon: false,
                        showChevron: false,
                        placeholder: "00:00",
                        setDefaultDate: _ctx.isDefaultValue && !!schedule.endTime,
                        key: schedule.endTime,
                        isError: schedule.isError
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "setDefaultDate", "isError"]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("td", null, [
                  (!schedule.isTransit)
                    ? (_openBlock(), _createBlock(_component_PvDropdown, {
                        key: 0,
                        modelValue: schedule.flightDay,
                        "onUpdate:modelValue": [($event: any) => (schedule.flightDay = $event), 
                  value => _ctx.formatCutOffDayValue({ value, index })
                ],
                        options: _ctx.options,
                        optionLabel: "name",
                        placeholder: "Pilih Hari",
                        class: "w-full plane-dropdown"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("td", null, [
                  _createVNode(_component_Datepicker, {
                    class: "mt-2 plane-datepicker",
                    modelValue: schedule.departureTime,
                    "onUpdate:modelValue": ($event: any) => (schedule.departureTime = $event),
                    showDatePicker: false,
                    showTimePicker: "",
                    manualInput: "",
                    showIcon: false,
                    showChevron: false,
                    placeholder: "00:00",
                    key: schedule.departureTime,
                    setDefaultDate: _ctx.isDefaultValue && !!schedule.departureTime
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "setDefaultDate"])
                ]),
                _createVNode("td", _hoisted_9, [
                  _createVNode(_component_lp_input, {
                    placeholder: "1440",
                    modelValue: schedule.flightTreshold,
                    "onUpdate:modelValue": ($event: any) => (schedule.flightTreshold = $event),
                    suffix: "menit",
                    format: _ctx.numberOnly,
                    error: schedule.flightTreshold > 1440,
                    isErrorIconCaption: false,
                    isErrorIconInput: false
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "format", "error"])
                ]),
                _createVNode("td", _hoisted_10, [
                  _createVNode(_component_PvDropdown, {
                    modelValue: schedule.dayTransit,
                    "onUpdate:modelValue": ($event: any) => (schedule.dayTransit = $event),
                    options: _ctx.optionDayTransit(schedule),
                    optionLabel: "name",
                    placeholder: "Jeda Transit",
                    class: "w-full plane-dropdown"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                ]),
                _createVNode("td", null, [
                  (
                  _ctx.checkTransit(schedule.transit, schedule.idParent, index) ||
                    _ctx.maxTransit(schedule.idParent)
                )
                    ? (_openBlock(), _createBlock("div", _hoisted_11))
                    : (_openBlock(), _createBlock(_component_LpButton, {
                        key: 1,
                        outline: "",
                        small: "",
                        title: "Transit",
                        textColor: "red-lp-100",
                        iconLeft: "plus-square",
                        iconColor: "red-lp-100",
                        iconV2: "",
                        class: "p-1",
                        onClick: ($event: any) => (_ctx.addTransit(schedule.idParent))
                      }, null, 8, ["onClick"]))
                ]),
                _createVNode("td", null, [
                  (
                  (schedule.orderTransit > 1 ||
                    schedule.transit.length === 0) &&
                    _ctx.dataShedule.length > 1
                )
                    ? (_openBlock(), _createBlock(_component_Icons, {
                        key: 0,
                        name: "trash-concentrated",
                        color: "#B82025",
                        class: "cursor-pointer w-4",
                        onClick: ($event: any) => (
                  _ctx.confirmDeleteSchedule(
                    schedule.idParent,
                    schedule.orderTransit
                  )
                )
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("tr", {
                class: `${!schedule.isError ? 'border-b border-gray-lp-400' : ''}`
              }, [
                _createVNode("td", {
                  colspan: _ctx.table.header.length,
                  class: "py-4 pl-18"
                }, [
                  _createVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createVNode("span", {
                      class: 
                    `pt-3 ${schedule.orderTransit === 1 ? 'pr-16' : 'pr-4'}`
                  
                    }, _toDisplayString(schedule.isTransit
                      ? `Transit ${schedule.orderTransit - 1}`
                      : "Bandara"), 3),
                    _createVNode("div", _hoisted_14, [
                      _createVNode(_component_SelectSearch, {
                        onFilter: _cache[1] || (_cache[1] = e => _ctx.fetchAirport(e)),
                        onFocus: _cache[2] || (_cache[2] = () => _ctx.fetchAirport('')),
                        modelValue: schedule.airportOrigin,
                        "onUpdate:modelValue": ($event: any) => (schedule.airportOrigin = $event),
                        isLoading: _ctx.isLoadingAirport,
                        options: _ctx.airportData,
                        keyName: "airportName",
                        keyValue: "airportCode",
                        placeholder: 
                      `Pilih bandara transit ${schedule.orderTransit}`
                    
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "isLoading", "options", "placeholder"])
                    ]),
                    _createVNode("div", _hoisted_15, [
                      _createVNode(_component_SelectSearch, {
                        onFilter: _cache[3] || (_cache[3] = e => _ctx.fetchAirport(e)),
                        onFocus: _cache[4] || (_cache[4] = () => _ctx.fetchAirport('')),
                        modelValue: schedule.airportDestination,
                        "onUpdate:modelValue": ($event: any) => (schedule.airportDestination = $event),
                        isLoading: _ctx.isLoadingAirport,
                        options: _ctx.airportData,
                        keyName: "airportName",
                        keyValue: "airportCode",
                        placeholder: 
                      `Pilih bandara transit ${schedule.orderTransit}`
                    
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "isLoading", "options", "placeholder"])
                    ])
                  ])
                ], 8, ["colspan"])
              ], 2),
              _withDirectives(_createVNode("tr", null, [
                _createVNode("td", {
                  colspan: _ctx.table.header.length,
                  class: "border-b border-gray-lp-400"
                }, [
                  _createVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createVNode("p", _hoisted_18, _toDisplayString(schedule.description), 1)
                  ])
                ], 8, ["colspan"])
              ], 512), [
                [_vShow, schedule.isError]
              ])
            ], 64))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_LpButton, {
      title: "Tambah Penerbangan",
      textColor: "white",
      iconLeft: "plus-square",
      iconColor: "white",
      iconV2: "",
      onClick: _ctx.addSchedule
    }, null, 8, ["onClick"]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.deleteSchedule,
      onClose: _ctx.closeConfirmation,
      title: "Hapus Jadwal Penerbangan?",
      message: "Data yang dihapus tidak dapat dikembalikan",
      image: "delete-confirm",
      reverseButton: true,
      textSuccess: "Ya, Hapus",
      textCancel: "Tidak",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.showDeleteConfirmation]
    ])
  ], 64))
})